import { makeStyles } from '@material-ui/core/styles';

export function useListTabPanelStyles() {
    const useStyles = makeStyles((theme) => ({
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingRight: theme.spacing(2),
        },
        search: {
            flex: 1
        },
        chipsBox: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: theme.spacing(1),
        },
    }));

    const classes = useStyles();

    return {
        classes,
    };
}